angular.module('identity').factory('tgAuth', function tgAuthFactory(tgIdentity, $q) {
	return {
		authorizeCurrentUserForRouteAs: function (role) {
			if (!!tgIdentity.currentUser && tgIdentity.currentUser.isAuthorizedFor(role)) {
				return true
			} else {
				return $q.reject('not authorized')
			}
		},
	}
})
